import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-bd",
  "use": "icon-icon-bd-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\" id=\"icon-icon-bd\">\n  <path fill=\"#006a4e\" d=\"M0 0h512v512H0z\" />\n  <circle cx=\"230\" cy=\"256\" r=\"170.7\" fill=\"#f42a41\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol